import React, { Component } from "react";
import { ContactForm, Layout, Wrapper, Title, SEO, Header } from 'components';
import styled from 'react-emotion';

const ContactSection = styled.section`
    text-align: center;
    width: 100%;
    margin-bottom: 8rem;
`;

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() {
        return ( 
            <Layout>
                {/* <SEO title={`${category} | ${website._title}`} pathname={location.pathname} /> */}
                <Header />
                    <Wrapper>
                    <ContactSection>
                        <ContactForm />
                    </ContactSection>
                </Wrapper>
            </Layout>
         );
    }
}
 
export default Contact;